import { render, staticRenderFns } from "./InfoLegal.vue?vue&type=template&id=5f97990a&scoped=true"
import script from "./InfoLegal.vue?vue&type=script&lang=js"
export * from "./InfoLegal.vue?vue&type=script&lang=js"
import style0 from "./InfoLegal.vue?vue&type=style&index=0&id=5f97990a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97990a",
  null
  
)

export default component.exports